import { Button, MenuItem } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useState } from 'react';
import {
    buildBackToBeginMessage,
    buildDataFormQAAfterSubmit,
    checkMessageOutOfSession,
    createMessageList,
    deleteMsgQA,
    postMessage,
    checkDataChangeInChatbot,
    buildFreeMessage,
    buildTheEndMessage,
    buildMessageConnecting,
    buildQAFormMessage
} from '../handler/ChatBoxHandler';
import { yupResolver } from '@hookform/resolvers';
import { FormProvider, useForm } from 'react-hook-form';
import CreateTicketQAOptionsLiveChat from '@/schema/CreateTicketQAOptionsLiveChat';
import RenderFieldUI from '@/component/formManagement/RenderFieldUI';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import SystemField, { TmpHiddenSysfieldInCreateTicket } from '@/common/constant/SystemField';
import { useEffect } from 'react';
import '@/component/multiPanel/TicketDetail.css';
import { isInputAllFieldRequired } from '@/component/ticketList/handler/CreateTicketCommonHandler';
import { cloneDeep } from 'lodash';
import { validateErrorTicket } from '@/component/common/ValidateTicket';
import {
    onSubmitCreateAnonymousQa,
} from '@/component/supportIframe/handler/AnonymousQAHandler';
import {
    getFormByIdWithoutAuthen,
    getInfoFormFieldWithoutAuthen
} from '@/service/formManagementService';
import LoadingMessage from '../LoadingMessage';
import { createKibanaDataContentOperation, getLastQaCategory } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { useRecoilState } from 'recoil';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';

export default function QAFormOptionLiveChat({
    message,
    setMessages,
    settingChatBot,
    messages,
    supportThreadIdState,
    affiliationOrganization,
    isModePreview,
    listCategories,
    API,
    categoryIdSelected,
    projectId,
    setFormDataTransfer,
    isMaximizedPanel,
    projectAlias,
    subDomain,
    setIsShowModalReload,
    setIsActivateLiveChat,
    setSupportTicketId,
    isIframeChatBot
}) {
    const getSelectedOption = () => {
        let selectedOption = {};
        if (!Utils.isEmptyArray(messages)) {
            let lastCategoryListSelected = {};
            messages.forEach(messageItem => {
                if (messageItem.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM) {
                    lastCategoryListSelected = messageItem;
                }
            });

            if (!Utils.isEmptyObject(lastCategoryListSelected)) {
                let lastCategorySelectedId = lastCategoryListSelected.idMessage;
                messages.forEach(msgItem => {
                    if (
                        msgItem.messageType ===
                            Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM &&
                        msgItem.idMessage > lastCategorySelectedId &&
                        msgItem.idOfTagField &&
                        msgItem.idOfOption
                    ) {
                        if (selectedOption.hasOwnProperty(msgItem.idOfTagField)) {
                            selectedOption[msgItem.idOfTagField].push(msgItem.idOfOption);
                        } else {
                            selectedOption[msgItem.idOfTagField] = [msgItem.idOfOption];
                        }
                    }
                });
            }
        }

        return selectedOption;
    };

    let selectedTagItemDataList = getSelectedOption();
    // field list data
    const [fieldListData, setFieldListData] = useState([]);
    let [formSaveData, setFormSaveData] = useState(selectedTagItemDataList);
    // selected form detail
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [autoFillObject, setAutoFillObject] = useState({});
    const [isExChangeTagField, setIsExChangeTagField] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingQAForm, setIsLoadingQAForm] = useState(false);
    const [listCategorieQA, setListCategorieQA] = useState(listCategories);
    const [onChangeEdit,setOnChangeEdit] = useState(false);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);

    const anonymousUserInfoKey = [
        'mailAddress',
        'reEmailAddress',
        'firstName',
        'lastName',
        'lastNameKana',
        'firstNameKana'
    ];

    const validateCreateTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: yupResolver(CreateTicketQAOptionsLiveChat(fieldListData))
    });

    const onSubmitCreateTicket = async data => {
        setIsLoading(true);
        let formData = {};
        for (const key in data) {
            if (!anonymousUserInfoKey.includes(key)) {
                formData[`${key}`] = data[`${key}`];
            }
        }
        const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
        // validate
        if (validateErrorTicket({ fieldListData: fieldListData }, fields)) {
            setIsLoading(false);
            return;
        }

        if (isModePreview) {
            let dataQA = {
                fieldListData: fieldListData,
                formDataTranfer: data,
                fileUploadList: fileUploadList
            };
            return sendMsgAfterSubmit(dataQA);
        }

        let formDetails = await getFormByIdWithoutAuthen(API, data.formSelected);

        if (Utils.isEmptyObject(formDetails)) {
            setIsLoading(false);
            return;
        }

        if (!formDetails.usingProjects.includes(projectId)) {
            setIsShowModalReload(true);
            return;
        }

        let categoryId = message?.categoryIdSelected;

        let validatedChangeData = await checkDataChangeInChatbot(
            projectAlias,
            subDomain,
            settingChatBot,
            categoryId,
            listCategorieQA,
            projectId,
            isIframeChatBot
        );

        if (!validatedChangeData.status && Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)) {
            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        // check case change form but dont change options 

        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
                settingChatBot.actionWhenNotResolve
        ) {
            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        // build free msg 
        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
                Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE
        ) {
                deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                message?.idQA
            );

            const freeMessage = buildFreeMessage(validatedChangeData.chatbotSettingNew.freeMsg, 0);
            const theEndMessage = buildTheEndMessage(
                1,
                message?.formQASystem
            );
            createMessageList(
                [freeMessage, theEndMessage],
                supportThreadIdState,
                affiliationOrganization,
                isModePreview
            );

            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
                Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH
        ) {
            deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                message?.idQA
            );

            let messageQA = {
                isDefault: false,
                data: {
                    categoryIdSelected: message?.categoryIdSelected,
                    formQASystem: message?.formQASystem,
                }
            };
            const newMessage = buildQAFormMessage(messageQA);
            postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);

            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        setFormDataTransfer(data);
        let cloneData = cloneDeep(data);
        for (const fieldId in cloneData) {
            let field = fieldListData.find(x => x.id === fieldId);
            if (field && field.type === Constant.FORM_TYPE.FIELD_URL && cloneData[fieldId]) {
                cloneData[fieldId] = cloneData[fieldId]?.split('\n');
            }

            if (field && field.type === Constant.FORM_TYPE.FIELD_TAG && cloneData[fieldId]) {
                let tagFiledValue = cloneData[fieldId];
                let listTagItem = [];
                for (let i = 0; i < cloneData[fieldId].length; i++) {
                    listTagItem.push(tagFiledValue[i].value);
                }
                cloneData[fieldId] = JSON.stringify(listTagItem);
            }
        }
        setFormSaveData(cloneData);
        await handleSubmitCreateTicket(data, formData);
    }

    const handleSubmitCreateTicket = async (data, formData) => {
        let anonymousUserInfo = {};
        let submitResponse = {};
        for (const key in data) {
            if (anonymousUserInfoKey.includes(key)) {
                anonymousUserInfo[`${key}`] = data[`${key}`] ? data[`${key}`] : '';
            }
        }
        anonymousUserInfo.type = Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT;
        formData.fileUploadList = fileUploadList;
        let params = {
            API: API,
            setFileUploading: setFileUploading
        };

        submitResponse = await onSubmitCreateAnonymousQa(
            params,
            formData,
            anonymousUserInfo,
            affiliationOrganization,
            projectId,
            fieldListData,
            {},
            true,
            supportThreadIdState
        );

        if (submitResponse?.data?.id) {
            setSupportTicketId(submitResponse?.data?.id)
            //redirect
            deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                message?.idQA
            );
            let dataQA = {
                fieldListData: fieldListData,
                formDataTranfer: data,
                fileUploadList: fileUploadList
            };
            setIsLoading(false);
            let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
            let dataLog = {
                rootCorporationDetail: {
                    id: affiliationOrganization
                },
                rootProjectDetail: {
                    id: projectId
                },
                corporationDetail: {},
                projectDetail: {},
                userDetail: {},
                ticketDetail: {
                    id: submitResponse?.data?.id,
                    outline: submitResponse?.data?.outline,
                    creator: '',
                    usingFormName: '',
                    createdAt: submitResponse?.data?.createdAt,
                },
                metaData: {
                    formDetailId: formData.formSelected,
                    ticketType: Constant.TICKET_TYPE.QA
                },
                qaCategory: getLastQaCategory(messages),
                ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.KNOWLEDGE_ROBO
            }
        
            let logKibanaData = createKibanaDataContentOperation(
                lastUserAction,
                dataLog
            );
            let param = {
                logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
                logKibanaData: logKibanaData
            };
            createKibanaLogAPI(API, param);
            setLastUserAction(null)
            return sendMsgAfterSubmit(dataQA);
        } else if (!Utils.isEmptyArray(submitResponse.errors)) {
            setIsLoading(false);
            let messageCode = submitResponse.errors[0].message;
            setIsLoading(false)
        }
    };

    const handleSubmitCreateTickets = validateCreateTicket.handleSubmit;
    const errorCreateTicket = validateCreateTicket.errors;
    const clearErrors = validateCreateTicket.clearErrors;
    const setValueCreateTicket = validateCreateTicket.setValue;
    const registerCreateTicket = validateCreateTicket.register;
    const getValuesCreateTicket = validateCreateTicket.getValues;
    const setErrorCreateTicket = validateCreateTicket.setError;

    const onCancelQAForm = () => {
        if (checkMessageOutOfSession(messages, message.idMessage)) return;
        const newMessage = buildBackToBeginMessage(
            'CBOTMSG013',
            0,
            message?.formQASystem
        );
        deleteMsgQA(
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview,
            message?.idQA
        );
        postMessage(
            newMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview
        );
        setMessages(prev => [...prev.slice(0, -1), newMessage]);
    };

    const sendMsgAfterSubmit = data => {
        if (checkMessageOutOfSession(messages, message?.idMessage)) return;
        const messageQA = buildDataFormQAAfterSubmit(data, 0, Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT);
        createMessageList(
            [messageQA],
            supportThreadIdState,
            affiliationOrganization,
            isModePreview
        );
        setMessages(prev => [...prev.slice(0, -1), messageQA]);
        setIsActivateLiveChat(true)
    };

    const getFormFieldData = (formStructure, fieldList) => {
        let formData = [];

        if (!Utils.isEmptyObject(formStructure)) {
            for (const fieldNumber in formStructure) {
                if (formStructure.hasOwnProperty(fieldNumber)) {
                    let fieldData = {};
                    let fieldId = '';
                    let formField = formStructure[fieldNumber];

                    if (
                        formStructure[fieldNumber].hasOwnProperty('field') &&
                        !Utils.isEmptyArray(fieldList)
                    ) {
                        fieldId = formStructure[fieldNumber]['field'];
                        fieldData = fieldList.find(customField => customField.id === fieldId);
                        console.log('fieldData', fieldData)
                        if (!Utils.isEmptyObject(fieldData)) fieldData.structure = Utils.convertJSONDataToObject(fieldData?.structure);
                    } else if (
                        formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                        !Utils.isEmptyArray(SystemField)
                    ) {
                        fieldId = formStructure[fieldNumber]['sysfield'];
                        fieldData = SystemField.find(systemField => systemField.id === fieldId);
                    }

                    if (!Utils.isEmptyObject(fieldData)) {
                        fieldData.fieldId = fieldId;
                        fieldData.fieldLabel = fieldData.name;
                        fieldData.structure.required = formField.required;
                        fieldData.structure.publicForCustomer = formField.publicForCustomer;
                        formData.push(fieldData);
                    }
                }
            }
        }

        return formData;
    };

    const getFormSelectedFromQACategory = async (categoryId, data) => {
        if (Utils.isEmpty(listCategorieQA)) return;
        let categoryDetail = listCategorieQA.filter(category => category.id === categoryId);
        let resFormField = categoryDetail[0]?.formfieldAnonymous;

        // get new info form ---------------------------
        let formId = resFormField?.id;
        let formfieldAnonymous = await getInfoFormFieldWithoutAuthen(API, formId);

        // new info form --------------------------------
        if (
            Utils.isEmptyObject(formfieldAnonymous) ||
            Utils.isEmptyString(formfieldAnonymous?.id)
        ) {
            return getFormSystemQA(data);
        }

        if (!formfieldAnonymous?.usingProjects.includes(projectId)) {
            return getFormSystemQA(data);
        }

        setValueCreateTicket('formSelected', formfieldAnonymous?.id);
        let getFieldListResult = getFormFieldData(
            formfieldAnonymous?.structure,
            formfieldAnonymous?.listFieldDetail
        );
        getFieldListResult = getFieldListResult.filter(x => {
            return (
                (Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW) &&
                !TmpHiddenSysfieldInCreateTicket.includes(x.sysField)
            );
        });
        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }
            return field;
        });

        // Get field order in form
        let fieldOrderInForm = {};

        if (!Utils.isEmptyObject(formfieldAnonymous?.structure)) {
            for (const [structureKey, structureValue] of Object.entries(
                formfieldAnonymous?.structure
            )) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }

        getFieldListResult = getFieldListResult
            .filter(field => {
                if (!field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField))
                    return true;
                return false;
            })
            .filter(
                field =>
                    field.sysField ||
                    field?.usingProjects?.includes(formfieldAnonymous?.affiliationProject)
            )
            .sort((a, b) => {
                if (a.sysField === 'attachments') {
                    return 1; // put `specificItem` at the bottom
                }

                if (b.sysField === 'attachments') {
                    return -1; // put `specificItem` at the bottom
                }

                // if (!a.order || !b.order) return 1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });

        setFieldListData([...getFieldListResult]);
        setFormSaveData(selectedTagItemDataList);
    };

    const getFormSystemQA = data =>  {
        let formfieldAnonymous = data;
        
        let getFieldListResult = getFormFieldData(
            formfieldAnonymous?.structure,
            formfieldAnonymous?.listFieldDetail
        );
        getFieldListResult = getFieldListResult.filter(x => {
            return (
                (Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW) &&
                !TmpHiddenSysfieldInCreateTicket.includes(x.sysField)
            );
        });
        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }
            return field;
        });

        // Get field order in form
        let fieldOrderInForm = {};

        if (!Utils.isEmptyObject(formfieldAnonymous?.structure)) {
            for (const [structureKey, structureValue] of Object.entries(
                formfieldAnonymous?.structure
            )) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }

        getFieldListResult = getFieldListResult
            .filter(
                field =>
                    !field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)
            )
            .sort((a, b) => {
                if (a.sysField === 'attachments') {
                    return 1; // put `specificItem` at the bottom
                }

                if (b.sysField === 'attachments') {
                    return -1; // put `specificItem` at the bottom
                }

                // if (!a.order || !b.order) return 1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });
        setValueCreateTicket('formSelected', formfieldAnonymous?.id);
        setFieldListData([...getFieldListResult]);
        setFormSaveData(selectedTagItemDataList);
    };

    const checkIsDisableBtnSubmit = () => {
        if (!Utils.isEmptyObject(errorCreateTicket)) {
            return true;
        }
        if (!isInputAllFieldRequired(fieldListData, getValuesCreateTicket, fileUploadList)) {
            return true;
        }
        if (Utils.isEmptyArray(fieldListData?.filter(field => field.type !== 'WORKFLOW'))) {
            return true
        }
        return false;
    };

    useEffect(() => {
        (async () => {
            setIsLoadingQAForm(true);
            registerCreateTicket('formSelected');
            let isDefault = message?.isDefault;
            if (!isDefault) {
                await getFormSelectedFromQACategory(
                    message?.categoryIdSelected,
                    message?.formQASystem
                );
                setIsLoadingQAForm(false);
            } else {
                getFormSystemQA(message?.formQASystem);
                setIsLoadingQAForm(false);
            }
        })();
    }, [categoryIdSelected, message?.formQASystem]);

    const getDefaultValueOfField = fieldData => {
        if (!fieldData || !fieldData.fieldId) return;

        return formSaveData && formSaveData[fieldData.fieldId]
            ? formSaveData[fieldData.fieldId]
            : null;
    };

    return (
        <div className={isMaximizedPanel ? 'message-text maximized-form-text' : 'message-text'}  >
            {isLoadingQAForm ? <LoadingMessage /> : (
                <div>
                    <div>{message.content[0]}</div>
                    <div className="info-form-anonymous">
                        <FormProvider {...validateCreateTicket}>
                            {!Utils.isEmptyArray(fieldListData) &&
                                fieldListData
                                    ?.filter(field => field.type !== 'WORKFLOW')
                                    .map((fieldData, i) => (
                                        <RenderFieldUI
                                            API={API}
                                            UI={fieldData.structure.UI}
                                            isNotAuthen={true}
                                            label={
                                                fieldData.fieldLabel
                                                    ? Utils.getTextByLanguage(
                                                          Constant.LANGUAGE_TYPE.JP,
                                                          fieldData.fieldLabel
                                                      )
                                                    : ''
                                            }
                                            errorlist={errorCreateTicket}
                                            name={fieldData.fieldId}
                                            data={fieldData}
                                            key={fieldData.fieldId}
                                            defaultValue={getDefaultValueOfField(fieldData)}
                                            // Drop file props
                                            fileUploadList={fileUploadList}
                                            setFileUploadList={setFileUploadList}
                                            register={registerCreateTicket}
                                            setValue={setValueCreateTicket}
                                            getValues={getValuesCreateTicket}
                                            clearErrors={clearErrors}
                                            autoFillObject={autoFillObject}
                                            setAutoFillObject={setAutoFillObject}
                                            isExChangeTagField={isExChangeTagField}
                                            setIsExChangeTagField={setIsExChangeTagField}
                                            listFieldEdited={listFieldEdited}
                                            setListFieldEdited={setListFieldEdited}
                                            isEdited={isEdited}
                                            setIsEdited={setIsEdited}
                                            isMaximizedPanel={isMaximizedPanel}
                                            isTooltipTitle={true}
                                            setOnChangeEdit={setOnChangeEdit}
                                            onChangeEdit = {onChangeEdit}
                                            isLoading={isLoading}
                                            setIsLoading={setIsLoading}
                                        />
                                    ))}
                        </FormProvider>
                    </div>
                    <div className='submit-form-anonymous-chatbot-group-btn'>
                        <Button
                            className={`submit-form-anonymous-chatbot ${checkIsDisableBtnSubmit() &&
                                'submit-form-anonymous-chatbot-disabled'}`}
                            disabled={checkIsDisableBtnSubmit() || isLoading}
                            onClick={handleSubmitCreateTickets(
                                async data => await onSubmitCreateTicket(data)
                            )}
                        >
                            {isLoading ? (
                                <span className="lds-dual-ring"></span>
                            ) : (
                                I18n.get('USER04BTN001')
                            )}
                        </Button>
                        <Button className={`cancel-form-anonymous-chatbot`} onClick={onCancelQAForm}>
                            {I18n.get('COMBTN001')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}
